// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"7c5be674","40":"6518a2a1","71":"fdbcd3e3","133":"01316ed7","391":"eac314d9","415":"03eb6301","423":"90bbdc84","622":"8dc8514b","743":"630e8ac1","906":"e072bd4b","917":"ee893618"}[chunkId] + ".chunk.js";
};